
import * as Yup from 'yup'

export const reportValidationSchema = Yup.object({
  customer: Yup.string().nullable(),
  service: Yup.string().nullable(),
  report_name: Yup.string().nullable(),
  start_date: Yup.date().max(
    new Date(new Date().setHours(23, 59, 59, 999)).toISOString().split('T')[0],
    'Start Date must be a date less than or equal to today'
  ),
  end_date: Yup.date()
    .max(new Date().toISOString().split('T')[0], 'End Date must be a date before tomorrow')
    .min(Yup.ref('start_date'), "End Date can't be before the Start Date."),
  service_id: Yup.string().nullable(),
  campaign_name: Yup.string().nullable(),
  operator_id: Yup.string().nullable(),
  operation_type: Yup.string().nullable(),
  domain_id: Yup.string().nullable()
})